import { ORG_HQ } from "./appConstants";

export const CompanyTypes = [
    { code: "Branch", title: "Branch" },
    { code: "Distributor", title: "Distributor" },
    { code: "DstBranch", title: "Distributor (Branch)" },
    { code: "DstHQ", title: "Distributor (HQ)" },
    { code: "DstHQBranch", title: "Distributor (HQ + Branch)" },
    { code: ORG_HQ, title: "HQ" },
    { code: "SubDstDst", title: "Sub Distributor (Distributor)" },
    { code: "SubDstDstBranch", title: "Sub Distributor [Distributor (Branch)]" }
]

export const AdminTypes = [
    { code: "S", title: "Super Admin" },
    { code: "M", title: "Manager" },
    { code: "U", title: "User" }
]

export const AdminFunctions = [
    { code: "CS", title: "Customer service" },
    { code: "Sales", title: "Sales" },
    { code: "Marketing", title: "Marketing" }
]

export const AdminPosition = [
    { code: "servicemanager", title: "Service manager" },
    { code: "salesmanager", title: "Sales manager" },
    { code: "marketingmanager", title: "Marketing manager"},
    { code: "ceo", title: "CEO" },
    { code: "staff", title: "Staff" }
]

export const WarrantyProductType = [
    { code: "CT", title: "CT" },
    { code: "UP KIT", title: "Ceph UP KIT" },
    { code: "PRD", title: "Product" },
]

export const WarrantyUPKitModel = [
    { code: "Ceph UP KIT", title: "Ceph UP KIT" }
]

export const DeviceModels = [
    { code: "RAYSCAN α (NEW) 2D", title: "RAYSCAN α (NEW) 2D" },
    { code: "RAYSCAN α 2DN", title: "RAYSCAN α 2DN" },
    { code: "RAYSCAN α", title: "RAYSCAN α" },
    { code: "RAYSCAN m+", title: "RAYSCAN m+" },  //RCT710
    { code: "RAYSCAN α (NEW) 3D", title: "RAYSCAN α (NEW) 3D" },
    { code: "RAYSCAN α+", title: "RAYSCAN α+" },  //RCT700
    { code: "RAYSCAN Studio", title: "RAYSCAN Studio" },  //RCT800
    { code: "RAYSCAN m+ (New)", title: "RAYSCAN m+ (New)" },
    { code: "RAYSCAN α+ (NEW)", title: "RAYSCAN α+ (NEW)" },
    { code: "R2 Studio Q", title: "R2 Studio Q" },
    { code: "RAY PreMiere", title: "RAY PreMiere" }, 
]

export const sDeviceModels = [
    { code: "RIOSCAN", title: "RIOSCAN" },
    { code: "RIOSensor (RIS500)", title: "RIOSensor (RIS500)" },
    { code: "RIOSensor (RIS510)", title: "RIOSensor (RIS510)" },
    { code: "RIOSensor+", title: "RIOSensor+" },
    { code: "RAYDENT Studio", title: "RAYDENT Studio" },
    { code: "RAYDENT Mill 4X", title: "RAYDENT Mill 4X" },
    { code: "RAYDENT Mill 5X", title: "RAYDENT Studio" },
    { code: "RAYMill C", title: "RAYMill C" },
]

export const SpecialityTypes = [
    { code: "GP", title: "General Practitioner (GP)" },
    { code: "Pros", title: "Prosthodontist" },
    { code: "Endo", title: "Endodontist" },
    { code: "Perio", title: "Periodontists" },
    { code: "Ortho", title: "Orthodontist" },
    { code: "Ped", title: "Pediatric Dentist" },
    { code: "Oral", title: "Oral and Maxillofacial Surgeon" },
    { code: "Public", title: "Public Health Dentist" },
    { code: "Rad", title: "Radiologist" },
    { code: "Other", title: "Other" },
]

export const RayModels = [
    { code: "Endo", title: "Endodontist" },
    { code: "Foren", title: "Forensic Dentists" },
    { code: "GP", title: "General Practitioner (GP)" },
    { code: "Oral", title: "Oral and Maxillofacial Surgeon" },
    { code: "Ortho", title: "Orthodontist" },
    { code: "Other", title: "Other" },
    { code: "Ped", title: "Pediatric Dentist" },
]

export const RayStatuses = [
    { code: "New", title: "New" },
    { code: "Visit", title: "To Visit" },
    { code: "Remote", title: "Remote Support" },
    { code: "Monitoring", title: "Monitoring" },
    { code: "Escalate", title: "Escalated" },
    { code: "Cancel", title: "Canceled" },
    { code: "Close", title: "Closed" },
]

export const RayIssueTypes = [
    { code: "", title: "Common" },
    { code: "ERRORCODE", title: "ErrorCode" },
]

export const RayTranslateLanguages = [
    { code: 'eng', title: 'English' },
    { code: 'kor', title: 'Korean' },
    { code: 'deu', title: 'German' },
    { code: 'spa', title: 'Spanish' },
    { code: 'fre', title: 'French' },
    { code: 'jpn', title: 'Japanese' },
    { code: 'cmn', title: 'Chinese - Simplified' },
    { code: 'zhh', title: 'Chinese - Traditional' },
    { code: 'ita', title: 'Italian' },
    { code: 'slk', title: 'Slovak' },
    { code: 'pol', title: 'Polish' },
    { code: 'ron', title: 'Romanian' },
    { code: 'ces', title: 'Czech' },
    { code: 'por', title: 'Portuguese' },
    { code: 'swe', title: 'Swedish' },
    { code: 'ell', title: 'Greek' },
    { code: 'tur', title: 'Turkish' },
    { code: 'rus', title: 'Russian' },
    { code: 'kaz', title: 'Kazakh' },
];

export const GetRayDeviceGuide = (model, ceph) => {
    const spacetxt = "Width door: 800mm (31.5＂) \n Width: 2,138mm (84.2＂) \n Depth: 1,700mm (66.9＂) \n Height: 2,500mm (98.4＂)";
    let imgUrl = "/assets/img/roomdimension/Ceph.JPG";

    if (model == 'RAYSCAN m+' || model == 'RAYSCAN m+ (New)') {
        if (ceph == 'NOCEPH') {
            imgUrl = "/assets/img/roomdimension/mplusnoceph.png";
        } else {
            imgUrl = "/assets/img/roomdimension/mplusceph.png";
        }
    } else {
        if (ceph == "NOCEPH") {
            imgUrl = "/assets/img/roomdimension/No_Ceph.JPG";
        } else {
            imgUrl = "/assets/img/roomdimension/Ceph.JPG";
        }
    }

    return {
        space: spacetxt,
        img: imgUrl,
    }
}

export const RayCsPotalLink = [
    { code: 'lv4', title: 'https://partner.raymedical.com/?autologin_code=IKMqLobcisfFYxvQge6rzEGo1DZfLJ'},
    { code: 'lv7', title: 'https://partner.raymedical.com/?autologin_code=hkggy1y3eLES9kmAYMhiQBjoWdHGta'},
];

export const RAYFACE = "RAYFACE";
export const CTSegmentation = { appId: "App-CTSegmentation", name: "CT Segmentation", pid: "4is86609-c37b-41fe-ac15-0c0fff2db0qq" };
export const FaceAnalyzer = { appId: "App-FaceAnalyzer", name: "Face Analyzer", pid: "1is87709-c37b-41fe-ac15-0c0fff2db0ii" };
export const SmartDentFiveD = { appId: "App-SmartDentFiveD", name: "SmartDent 5D" };
export const TEMPS = {
    TEMPGroup : "tempgroup",
    TEMPMGroupId : "tempmgroupid",
    TEMPNtId : "tempntid",
    TEMPUser : "tempuser"
}